/**
 * Silence verbose console output in PRODUCTION builds.
 *
 * The app has ~1,500 debug console.log/.info/.debug calls that flood the console
 * on deployed environments (incl. Railway dev — both Railway dev and prod build
 * with NODE_ENV=production via CRA's `react-scripts build`). This no-ops those
 * three methods in production while KEEPING console.error and console.warn so
 * real problems still surface.
 *
 * Local development (`npm start`, NODE_ENV=development) is unaffected — all logs
 * still print, so day-to-day debugging keeps full output.
 *
 * SIDE EFFECT ON IMPORT: simply importing this module applies the silencing, so
 * it can be imported first in index.tsx without a separate call statement
 * between imports (keeps eslint import/first happy).
 *
 * To temporarily re-enable verbose logs on a deployed build, set
 * REACT_APP_VERBOSE_LOGS=true at build time.
 */
const isProd = process.env.NODE_ENV === 'production';
const verbose = process.env.REACT_APP_VERBOSE_LOGS === 'true';

if (isProd && !verbose) {
  const noop = () => {};
  // Keep error + warn; silence the noisy informational levels.
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

export {};
